import { render, staticRenderFns } from "./periodosSalle.vue?vue&type=template&id=05e6505c&scoped=true"
import script from "./periodosSalle.vue?vue&type=script&lang=js"
export * from "./periodosSalle.vue?vue&type=script&lang=js"
import style0 from "./periodosSalle.vue?vue&type=style&index=0&id=05e6505c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e6505c",
  null
  
)

export default component.exports